import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconDashboard(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
      >
        <path d="m4.5 17.5h9v-13h-9z" />
        <path d="m4.5 27.5h8.9997559v-7h-8.9997559z" />
        <path d="m17.5 27.5h9v-13h-9z" />
        <path d="m17.5 4.5v7h9v-7z" />
      </g>
    </Icon>
  )
}
